import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { PasswordResetForm } from '@/components/auth/PasswordResetForm';
import { redirectIfSignedIn } from '@/lib/use-session';

export const Route = createFileRoute('/auth/password-reset')({
  beforeLoad: ({ context }) => redirectIfSignedIn(context),
  component: PasswordResetPage,
});

function PasswordResetPage() {
  return (
    <AuthLayout
      kicker="Lost your password?"
      headline="We'll get you back in."
    >
      <PasswordResetForm />
    </AuthLayout>
  );
}
